import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {LoaderService} from '../shared/service/loader.service';
import {Subscription} from 'rxjs';
import {environment} from '../../environments/environment';

@Component({
  selector: 'frageboegen-app-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss']
})
export class ErrorComponent implements OnDestroy, OnInit {
  public routerLink = environment.redirectPath;
  status = null;
  header: string;
  message: string;
  secondMessage: string;
  linkLabel: string;
  linkValue: string;
  subscription: Subscription;
  headerQuestionnaire: string;
  messageQuestionnaire: string;
  landingpageLinkText: string;
  questionnaireLinkText: string;
  messageConjunct: string;

  constructor(private readonly route: ActivatedRoute,
              private readonly loadingService: LoaderService,
              private readonly router: Router) {
    loadingService.isLoading = {isLoading: false};
  }

  ngOnInit(): void {
    this.subscription = this.route.params.subscribe(param => {
      const errorIndex = 'error';
      this.status = param[errorIndex];
    });
    this.subscription.add(this.route.data.subscribe(data => {
      this.header = data.header;
      this.message = data.message;
      this.secondMessage = data.secondMessage;
      this.linkLabel = data.linkLabel;
      this.linkValue = data.linkValue;
      this.headerQuestionnaire = data.headerQuestionnaire;
      this.messageQuestionnaire = data.messageQuestionnaire;
      this.landingpageLinkText = data.landingpageLinkText;
      this.questionnaireLinkText = data.questionnaireLinkText;
      this.messageConjunct = data.messageConjunct;
    }));
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  navigateToOverview() {
    this.router.navigate([environment.redirectPath]);
  }
}
